import React, { useEffect } from "react";
import "./index.css";
import { Box, Tabs, Tab } from "@mui/material";
import { useWebServer } from "../../providers";
import CollectionSites from "../../components/DataTable/CollectionSites";
import { useAppSelector, useAppDispatch } from "../../stores/store";
import HeadLine from "../../components/HeadLine";
import { CollectionSite, TrapType } from "../../types";
import {
  updateCollectionSite,
  createCollectionSite,
  createTrapType,
  updateTrapType,
} from "../../stores/collectionSites/actions";
import TrapTypesTable from "../../components/DataTable/TrapTypes";
import TrapTypeCreationForm from "../../components/Modals/TrapTypeCreationForm";
import CollectionCreationForm from "../../components/Modals/TrapSiteCreationForm";
import { fetchTrapTypes } from "../../stores/collectionSites/actions";
import { fetchCollectionSites } from "../../stores/collectionSites/actions";

interface Props {}

const CollectionSiteView: React.FC<Props> = () => {
  const [value, setValue] = React.useState("0");
  const [modal, setModal] = React.useState(0);
  const collectionSites = useAppSelector(
    (state) => state.collectionSites.collectionSites
  );
  const trapTypes = useAppSelector((state) => state.collectionSites.trapTypes);
  const [collectionSiteFormData, setCollectionSiteFormData] =
    React.useState<CollectionSite>({
      displayName: "",
      address: "",
      description: "",
      gps: "",
    });
  const [trapTypeFormData, setTrapTypeFormData] = React.useState<TrapType>({});
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const dispatch = useAppDispatch();
  const { sendRequest } = useWebServer();
  const [open, setOpen] = React.useState(false);
  const collectionSitesOptionsLoading = useAppSelector(
    (state) => state.collectionSites.collectionSitesLoading
  );
  const trapTypesOptionsLoading = useAppSelector(
    (state) => state.collectionSites.trapTypesLoading
  );
  // fetch initial data
  useEffect(() => {
    dispatch(fetchCollectionSites(sendRequest));
    dispatch(fetchTrapTypes(sendRequest));
  }, [dispatch, sendRequest]);

  const handleOpen = () => {
    setCollectionSiteFormData({});
    setOpen(true);
    setModal(1);
  };

  const handleEdit = (data: CollectionSite) => {
    handleOpen();
    setCollectionSiteFormData(data);
  };

  const handleTrapTypeModalOpen = () => {
    setTrapTypeFormData({
      displayName: "",
      attractant: "",
      trapType: "",
      description: "",
    });
    setOpen(true);
    setModal(2);
  };

  const handleTrapTypeEdit = (data: TrapType) => {
    handleTrapTypeModalOpen();
    setTrapTypeFormData(data);
    if (data?.id) {
      dispatch(updateTrapType({ sendRequest, trapType: data }));
    } else {
      dispatch(createTrapType({ sendRequest, trapType: data }));
    }
  };

  const handleClose = () => {
    setOpen(false);
    setModal(0);
  };

  const handleCollectionSave = (data: CollectionSite) => {
    if (data?.id) {
      dispatch(updateCollectionSite({ sendRequest, collectionSite: data }));
    } else {
      dispatch(createCollectionSite({ sendRequest, collectionSite: data }));
    }
  };

  return (
    <>
      <div className="collections">
        <Box>
          <Box className="header-collections">
            <HeadLine value={"Edit Collection Details"} />
          </Box>
          <Box
            className="tabs-collections"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              centered
              variant="fullWidth"
            >
              <Tab label="COLLECTION SITES" value="0" />
              <Tab label="COLLECTION METHOD" value="1" />
            </Tabs>
          </Box>
        </Box>
        {value === "0" && (
          <div className="collection-content">
            <CollectionSites
              loading={collectionSitesOptionsLoading}
              collectionSites={collectionSites}
              handleOpen={handleOpen}
              handleEdit={handleEdit}
            />
          </div>
        )}

        {value === "1" && (
          <Box className="collection-content">
            <TrapTypesTable
              loading={trapTypesOptionsLoading}
              trapTypes={trapTypes}
              handleOpen={handleTrapTypeModalOpen}
              handleEdit={handleTrapTypeEdit}
            />
          </Box>
        )}

        {modal === 1 && (
          <CollectionCreationForm
            open={open}
            formData={collectionSiteFormData}
            handleClose={handleClose}
            handleSave={handleCollectionSave}
          />
        )}

        {modal === 2 && (
          <TrapTypeCreationForm
            open={open}
            formData={trapTypeFormData}
            handleClose={handleClose}
            handleSave={handleTrapTypeEdit}
          />
        )}
      </div>
    </>
  );
};

export default CollectionSiteView;
